import { useEffect, useState, useContext } from 'react';

import { HOME_EXPERIENCE } from '@confluence/experience-tracker/entry-points/ExperienceName';
import { ExperienceTrackerContext } from '@confluence/experience-tracker/entry-points/component';
import { isStop } from '@confluence/experience-tracker/entry-points/ExperienceEvent';

export const useHomeReadyForUser = () => {
	const experienceTracker = useContext(ExperienceTrackerContext);
	const [homeReadyForUser, setHomeReadyForUser] = useState(false);

	useEffect(() => {
		if (experienceTracker.getExperienceState(HOME_EXPERIENCE)?.hasStopped) {
			setHomeReadyForUser(true);
		}

		return experienceTracker.subscribe((event) => {
			if (event.name === HOME_EXPERIENCE && isStop(event)) {
				setHomeReadyForUser(true);
			}
		});
	}, [experienceTracker]);

	return homeReadyForUser;
};
